import { modelOptions, mongoose, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../schemaBase.js";

const SCHEMA_KEY = "ArchivedLogsBatch" as const;

type LogBatchStatus = "uploading" | "verifying" | "verified";
type LogType = "SproutLogger";

@modelOptions({
    schemaOptions: {
        collection: "archivedlogsbatches",
        timestamps: true,
        ...getDefaultSchemaOptions(SCHEMA_KEY),
        _id: true,
    },
})
@post<SchemaBase<ArchivedLogsBatch>>(...addSchemaKeyHook(SCHEMA_KEY))
export class ArchivedLogsBatch extends SchemaBase<ArchivedLogsBatch> {
    static schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    public _id!: mongoose.Types.ObjectId;

    @prop({ type: () => String, required: true })
    public deviceID!: string;

    @prop({ type: () => Number, required: true })
    public logCount!: number;

    @prop({ type: () => Date, required: true })
    public startDate!: Date;

    @prop({ type: () => Date, required: true })
    public endDate!: Date;

    @prop({ type: () => String, required: true })
    public bucketName!: string;

    @prop({ type: () => String, required: true })
    public fileName!: string;

    @prop({ type: () => String, required: true, default: "uploading" })
    public status: LogBatchStatus = "uploading";

    @prop({ type: () => String, required: true })
    public logType!: LogType;

    static getters = {
        /**
         * Returns whether the batch is fully processed and verified
         */
        isVerified: (self: ArchivedLogsBatch): boolean => self.status === "verified",
    } as const satisfies Record<string, (self: ArchivedLogsBatch) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<ArchivedLogsBatch>) {
        super(properties);
        Object.assign(this, properties);
    }
}
